import React from 'react'
import { Helmet } from 'react-helmet-async';
import GetInTouch from '../components/Home/GetInTouch';
import GetStarted from '../components/Home/GetStarted';
import Header from '../components/Home/Header';
import NuestrasInstalaciones from '../components/Home/NuestrasInstalaciones';
import NotasInformativas from '../components/Home/NotasInformativas';
import CoordinadorComponent from '../components/Home/CoordinadorComponent';
import CallDiplomados from '../components/Home/CallDiplomados';

const Home = () => {
  return (
    <>
    <Helmet>
      <title>Diplomado en Ultrasonografía Diagnóstica - IMDI Tuxtla</title>        
      <meta name="description" content="Capacítate en ultrasonografía diagnóstica con IMDI Tuxtla. Diplomados en ultrasonido, ecografía y doppler materno fetal con expertos médicos." />
      <meta name="keywords" content="diplomados en ultrasonografía, ultrasonido diagnóstico, ecografía médica, doppler materno fetal, maestría en ultrasonografía" />
      <meta name="author" content="IMDI Tuxtla" />
      <link rel="canonical" href="https://imdituxtla.com.mx/" />
    </Helmet>

    

    <Header />
    <GetStarted />
    <CoordinadorComponent />
    <NuestrasInstalaciones />
    <NotasInformativas />  
    <CallDiplomados />
    <GetInTouch />
    </>

  )
}

export default Home